
<div class="card info-wrapper" #infoDiv>
    <div class="card-body">

        <!-- Selected Alert Panel (flex column) -->
        <div *ngIf="selectedAlert !== null && selectedAlert !== undefined" class="selected-alert-panel">

        <!-- Top section of the right pannel -->
        <div class="info-panel-top">

            <div class="info-panel-top-header">
            <div class="logo-title-alert" placement="bottom">
                <img *ngIf="!!selectedAlert?.icon" [src]="selectedAlert?.icon" />
                <i *ngIf="!!selectedAlert.fa_icon" [class]="selectedAlert.fa_icon" [style.color]="selectedAlert.fa_color"></i>   
                {{ selectedAlert?.title }}
            </div>

            
            <div class="alert-icons" [ngClass]="selectedAlert?.isTest ? 'with-test' : 'no-test'">
                <span class="badge badge-warning badge-test" *ngIf="selectedAlert?.isTest">{{ 'alerts.status.test' | translate }}</span>
                <span 
                *ngIf="((selectedAlert.isShared && selectedAlert.allowIntervention) || !selectedAlert.isShared) && !displayArchivedAlerts && canShowActionPlanElements" 
                class="ml-2" 
                [ngClass]="selectedAlert?.sentToActionPlan === true ? '' : selectedAlert?.sentToActionPlan === false && selectedAlert?.status === 'TERMINATED' ? 'disabled' : (selectedAlert?.sentToActionPlan === false && (selectedAlert?.status === 'NEW' || selectedAlert?.status === 'IN PROGRESS')) ? 'click-icon' : ''" 
                (click)="selectedAlert?.sentToActionPlan === true || (selectedAlert?.sentToActionPlan === false && selectedAlert?.status === 'TERMINATED') ? '' : (selectedAlert?.sentToActionPlan === false && (selectedAlert?.status === 'NEW' || selectedAlert?.status === 'IN PROGRESS')) ? sendToActionPlan(selectedAlert) : ''" 
                placement="left">
                    <i class="fad fa-tasks-alt" [class.text-primary]="selectedAlert?.sentToActionPlan === true" [class.text-muted]="selectedAlert?.sentToActionPlan === false && selectedAlert?.status === 'TERMINATED'"></i>
                </span>
            </div>
            </div>

            <!-- Headband alert status -->
            <div class="headband-status headband-danger" *ngIf="selectedAlert?.status === 'NEW'">{{ 'alerts.status.pending' | translate }}</div>
            <div class="headband-status headband-primary" *ngIf="selectedAlert?.status === 'IN PROGRESS'">{{ 'alerts.status.ongoing' | translate }}</div>
            <div class="headband-status headband-success" *ngIf="selectedAlert?.status === 'TERMINATED'">{{ 'alerts.status.finished' | translate }}</div>
            <div class="headband-status headband-secondary" *ngIf="selectedAlert?.status === 'IGNORED'">{{ 'alerts.status.ignored' | translate }}</div>

            <!-- Creation date + interval date alert -->
            <div class="date-wrapper">
            <div class="model-info alert-received">
                <span class="info-icon">
                <i class="fad fa-clock"></i>
                </span>
                {{ selectedAlert.created_at.toLocaleString().replace(',','') }}
            </div>
            <div class="date-interval">
                {{ getTimeDifference(selectedAlert.created_at) }}
            </div>  
            </div>

            <!-- address -->
            <div class="model-info">
            <span class="info-icon">
                <i class="fad fa-map-marker-alt"></i>
            </span>
            {{ selectedAlert.address }}
            </div>
            <!-- lat lng -->
            <div class="model-info">
            <span class="info-icon">
                <i class="fad fa-location"></i>
            </span>
            {{ selectedAlert.lat }}, {{ selectedAlert.lng }}
            <span *ngIf="selectedAlert.accuracy !== null">({{ 'alerts.accuracy' | translate }}: {{ selectedAlert.accuracy.toFixed() }}m)</span>
            </div>
            <!-- creator name -->
            <div class="model-info">
            <span class="info-icon">
                <i class="fad fa-user-circle"></i>
            </span>
            {{ selectedAlert.creator_name ? selectedAlert.creator_name : 'Anonymous' }}
            </div>

            <!-- number phone -->
            <div class="model-info">
            <span class="info-icon">
                <i class="fad fa-phone"></i>
            </span>
            {{ selectedAlert.creator_phone ? selectedAlert.creator_phone : 'Unknown'  }}
            </div>

            <!-- Operator Name -->
            <div class="model-info" *ngIf="selectedAlert.operator_name !== undefined">
            <span class="info-icon">
                <i class="fad fa-star"></i>
            </span>
            {{ 'alerts.covered_by' | translate }} {{ selectedAlert.operator_name  }}
            </div>

            <!-- Actions Buttons -->
            <div class="info-panel-bottom-actions" *ngIf="((selectedAlert.isShared && selectedAlert.allowIntervention) || !selectedAlert.isShared) && canManageAlerts">
            
            <!-- UNARCHIVE ALERT (archived alerts only) -->
            <button *ngIf="!selectedAlert?.isLoading && displayArchivedAlerts" (click)="unarchiveAlert(selectedAlert, selectedAlert.status)" class="btn btn-secondary">
                {{ 'alerts.actions.unarchive_button' | translate }}
            </button>

            <!-- DELETED ALERT (archived alerts only) -->
            <button *ngIf="!selectedAlert?.isLoading && displayArchivedAlerts" (click)="deleteAlert(selectedAlert)" class="btn btn-danger">
                {{ 'alerts.actions.delete_button' | translate }}
            </button>

            <!-- WAITING -->
            <button *ngIf="!selectedAlert?.isLoading && (selectedAlert?.status === 'IN PROGRESS' || selectedAlert?.status === 'IGNORED') && !displayArchivedAlerts" [disabled]="selectedAlert?.sentToActionPlan === true" (click)="setWaitingAlert(selectedAlert)" class="btn btn-danger">
                {{ 'alerts.actions.back_to_pending_alert_button' | translate }}
            </button>

            <!-- IN PROGRESS -->
            <button *ngIf="!selectedAlert?.isLoading && (selectedAlert?.status === 'NEW' || selectedAlert?.status === 'TERMINATED' || selectedAlert?.status === 'IGNORED') && !displayArchivedAlerts" [disabled]="selectedAlert?.sentToActionPlan === true" (click)="updateAlertStatus(selectedAlert, 'IN PROGRESS')" class="btn btn-primary">
                {{ 'alerts.actions.take_charge_alert_button' | translate }}
            </button>

            <!-- TERMINATED -->
            <button *ngIf="!selectedAlert?.isLoading && selectedAlert?.status === 'IN PROGRESS' && !displayArchivedAlerts" [disabled]="selectedAlert?.sentToActionPlan === true" (click)="updateAlertStatus(selectedAlert, 'TERMINATED')" class="btn btn-success">
                {{ 'alerts.actions.finish_alert_button' | translate }}
            </button>
            
            <!-- ignoring button -->
            <button *ngIf="!selectedAlert?.isLoading && selectedAlert?.status === 'NEW' && !displayArchivedAlerts" [disabled]="selectedAlert?.sentToActionPlan === true" (click)="ignoreAlert(selectedAlert)" class="btn btn-secondary">
                {{ 'alerts.actions.ignore_alert_button' | translate }}
            </button>

            <!-- archiving button -->
            <button *ngIf="!selectedAlert?.isLoading && (selectedAlert?.status === 'TERMINATED' || selectedAlert?.status === 'IGNORED' || selectedAlert?.sentToActionPlan === true) && !displayArchivedAlerts" (click)="archiveAlert(selectedAlert)" class="btn btn-secondary">
                {{ 'alerts.actions.archive_alert_button' | translate }}
            </button>
            
            <!-- loading button -->
            <button *ngIf="selectedAlert?.isLoading" class="btn" [ngClass]="{'btn-primary': selectedAlert?.status === 'NEW', 'btn-secondary': selectedAlert?.status === 'IGNORED' || selectedAlert?.status === 'ARCHIVED', 'btn-success' : selectedAlert?.status === 'IN PROGRESS' }">
                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            </button>
            </div>

            <!-- intervention not allowed message -->
            <div class="info-panel-bottom-actions intervention-not-allowed" *ngIf="selectedAlert.isShared && !selectedAlert.allowIntervention">
            {{ 'alerts.actions.intervention_not_allowed_message' | translate }}
            </div>

        </div><!-- End of info-panel-top -->
                    
        <!-- Bottom section of the right pannel -->
        <ul ngbNav #nav="ngbNav" [(activeId)]="active_tab" class="nav-tabs" [animation]="navAnimated">
            <li [ngbNavItem]="1">
            <div class="title">
                <b><i class="fad fa-poll-h"></i> {{ 'alerts.alert_detail.tabs.information' | translate }}</b>
            </div>
            <ng-template ngbNavContent>

                <ul class="responses-list scroller">

                <li *ngFor="let response of selectedAlert.responses;">
                    <img *ngIf="response.icon !== null" [src]="response.icon" width="35" height="35" class="mr-2"/>
                    <i *ngIf="response.fa_icon !== null" [class]="response.fa_icon" class="fa-2x mr-2" [style.color]="response.fa_color" style="vertical-align: middle;"></i>   
                    <i *ngIf="response.icon === null && response.fa_icon === null" class="fad fa-question-circle fa-2x mr-2" style="vertical-align: middle;"></i>
                    <b class="question inline-center">{{ response.question }}</b><br />
                    <!-- list of choices response -->
                    <div *ngIf="response.type === 'MULTI_CHOICE' || response.type === 'SIMPLE_CHOICE'">
                    <span *ngIf="response.response.length > 0">
                        <span *ngFor="let choice of response.response; let i=index">
                        {{ choice?.response }}<span *ngIf="i !== response.response.length - 1"> | </span>
                        </span>
                    </span>
                    <span *ngIf="response.response.length === 0">
                        <i>{{ 'alerts.alert_detail.answers.no_answer_to_question' | translate }}</i>
                    </span>
                    </div>
                    <!-- photo response -->
                    <div *ngIf="response.type === 'PHOTO'">                  
                    <div *ngFor="let photo_src of response.response;">
                        <img [src]="photo_src" class="photo" (click)="photoDisplayModal(photo_src)"/>
                    </div>
                    </div>
                    <!-- video response -->
                    <div *ngIf="response.type === 'VIDEO'">
                    <div *ngFor="let url of response.response">
                        <video controls class="video"><source [src]="url"></video>
                    </div>
                    </div>
                    <!-- audio response -->
                    <div *ngIf="response.type === 'AUDIO'">
                    <div *ngFor="let url of response.response">
                        <audio controls><source [src]="url"></audio>
                    </div>
                    </div>
                    <!-- document response -->
                    <div *ngIf="response.type === 'DOCUMENT'">
                    <div *ngFor="let url of response.response">
                        <a target="_blank" rel="noopener noreferrer" [href]="url">{{ getDocumentFileUid(url) }} </a>
                    </div>
                    </div>
                    <!-- datetime response -->
                    <div *ngIf="response.type === 'DATETIME'">
                    <span *ngFor="let resp of response.response; let i = index;">
                        {{ resp }}<span *ngIf="i !== response.response.length - 1"> | </span>
                    </span>
                    </div>
                    <!-- all other types -->
                    <p *ngIf="response.type !== 'PHOTO' && response.type !== 'VIDEO' && response.type !== 'AUDIO' && response.type !== 'DOCUMENT' && response.type !== 'DATETIME' && response.type !== 'SIMPLE_CHOICE' && response.type !== 'MULTI_CHOICE' && response.response !== null">
                    {{ response.response }}
                    </p>
                    <!-- no response -->
                    <p *ngIf="response.response === null"><i>{{ 'alerts.alert_detail.answers.no_answer_to_question' | translate }}</i></p>
                </li>
                </ul>

            </ng-template>
            </li>

    
        </ul>

        <div [ngbNavOutlet]="nav"></div>

        </div><!-- End Alert Selected -->

        <div *ngIf="!selectedAlert" class="text-center">
            <i>{{ 'alerts.alert_detail.no_alert_selected' | translate }}</i>
        </div>

    </div>
</div><!-- End card -->
